import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useSupabase } from '../../contexts/SupabaseContext';
import { MODULES } from '../../config/modules';
import { adminErrorMessage, formatDateTime, ACTION_LABELS } from './adminShared';

const LIMIT = 200;
const targetLabel = (row) => (row.action.startsWith('module.') ? MODULES.find(m => m.key === row.target)?.name || row.target : row.target);

// Every admin action (written by the database, so it can't be edited from the app)
const AdminLog = () => {
  const { supabase } = useSupabase();
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    supabase
      .from('admin_audit_log')
      .select('id, admin_email, action, target, details, created_at')
      .order('created_at', { ascending: false })
      .limit(LIMIT)
      .then(({ data, error: loadError }) => {
        if (cancelled) return;
        if (loadError) setError(adminErrorMessage(loadError));
        else setRows(data || []);
      });
    return () => { cancelled = true; };
  }, [supabase]);

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!rows) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>;
  if (!rows.length) return <Paper sx={{ p: 5, textAlign: 'center' }}><Typography color="text.secondary">No admin actions yet.</Typography></Paper>;

  return (
    <Box>
      <Paper data-tour="admin-log" sx={{ overflow: 'hidden' }}>
        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table size="small" aria-label="Admin activity">
            <TableHead>
              <TableRow>
                <TableCell>When</TableCell>
                <TableCell>Admin</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>On</TableCell>
                <TableCell>Reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.id} hover>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDateTime(row.created_at)}</TableCell>
                  <TableCell>{row.admin_email || '—'}</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>{ACTION_LABELS[row.action] || row.action}</TableCell>
                  <TableCell>{targetLabel(row)}</TableCell>
                  <TableCell>{row.details?.reason || '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        The latest {LIMIT} actions. The log is written by the database and can't be changed from the app.
      </Typography>
    </Box>
  );
};

export default AdminLog;
